import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=0176a66f&"
import script from "./CourseOverview.vue?vue&type=script&lang=ts&"
export * from "./CourseOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports